// extracted by mini-css-extract-plugin
module.exports = {"column":"_4e5f713ae4--column--N1Ahw"};